import {SagaIterator} from 'redux-saga';
import {all, call} from 'redux-saga/effects';
import {adminSagas} from './admin/admin.watchers';
import {appointmentsSagas} from './appointments/appointments.watchers';
import {calendarSagas} from './calendar/calendar.watchers';
import {notificationsSagas} from './notifications/notifications.watchers';
import {patientsSagas} from './patients/patients.watchers';
import {postsSagas} from './posts/posts.watchers';
import {userSagas} from './user/user.watchers';

export default function* rootSaga(): SagaIterator<void> {
  yield all([
    call(userSagas),
    call(postsSagas),
    call(adminSagas),
    call(patientsSagas),
    call(appointmentsSagas),
    call(notificationsSagas),
    call(calendarSagas),
  ]);
}
